import { render } from "./YachtVesselDescription.vue?vue&type=template&id=72dfa192&scoped=true"
import script from "./YachtVesselDescription.vue?vue&type=script&lang=js"
export * from "./YachtVesselDescription.vue?vue&type=script&lang=js"

import "./YachtVesselDescription.vue?vue&type=style&index=0&id=72dfa192&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dfa192"]])

export default __exports__